import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { Nav } from "@repoflow/components/nav";
import * as Section from "@repoflow/components/section";
import SiteFilePublicSchema from "@common/schema/site-file/public";
import { IMAGES, DOCUMENTS, KIND_CONFIG } from "@common/schema/site-file/kind";
import * as KindRoute from "./kind";

// The site's Files section, and the Images / Documents submenu under it.
//
// This is the one screen in the app whose data is not in this service. A file's
// bytes are in bucketws — pagews holds a single bucketws service key and cuts
// two buckets per organization, one per kind — and what lives here is the index
// that says which of them belongs to which site. See docs/pagews-files.md.
//
// The two kinds are separate buckets rather than one bucket and a tag, which is
// why each carries its own extension allowlist and its own size ceiling:
// @common/schema/site-file/kind is where both are declared, and it is the same
// declaration the API provisions the bucket from.
const LocalProvider = ({
  match: { params },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/file`;
  const basepath = `${parentBasepath}/file`;

  return (
    <Section.Provider
      schema={SiteFilePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <Container className="mt-4">
            <Row>
              <Col>
                <Nav
                  // Named for the same reason the site's strip is: a spec has to
                  // be able to say "the Files submenu" without also matching the
                  // site's own tab strip, which is on screen at the same time
                  // and is also `.nav-tabs`.
                  id="site-file-tabs"
                  tabs
                  // `base`, not `basepath` — Nav uses `route` for the active
                  // check AND for the navigation, so a pattern here would send
                  // the browser to the literal "/site/:siteId/file/images".
                  sections={[
                    { label: KIND_CONFIG[IMAGES].label, route: `${base}/${IMAGES}` },
                    { label: KIND_CONFIG[DOCUMENTS].label, route: `${base}/${DOCUMENTS}` },
                  ]}
                />
              </Col>
            </Row>
          </Container>

          <Switch>
            <Route path={`${basepath}/:kind`} component={KindRoute.Content} />
            {/* Images is the landing kind, the way the archived project had it
                — a site has a logo before it has a press pack. A redirect
                rather than rendering the list directly, so the tab strip above
                has a route to mark active. */}
            <Route
              path={basepath}
              component={() => <Redirect to={`${base}/${IMAGES}`} />}
            />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Files</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/:kind`} component={KindRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
